import React, { useEffect, useState } from "react";
import AddDetails from "./AddDetails";
import RoleApi from "../../api/RoleApi";
import { formatDate } from "../../helpers/helper";
import EditDetails from "./EditDetails";

import Auth from "../../utils/AuthUtils";
import { can } from "../../utils/permissionUtils";

function List() {
  const [roleData, setRoleData] = useState([]);
  const [editData, setEditData] = useState();
  const [selectedRole, setSelectedRole] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const user = Auth.getUserDetails();
  const permissions = user?.permissions;

  useEffect(() => {
    fetchRoleData();
  }, []);

  const fetchRoleData = async () => {
    const res = await RoleApi.list();
    if (res.code === 200) {
      setRoleData(res.data);
    }
  };

  const handleDelete = async () => {
    try {
      // ✅ Security Check: delete permission
      if (!can(permissions, "delete", "role")) return;

      const res = await RoleApi.delete({ id: selectedRole._id });

      if (res.code === 200) {
        const modalEl = document.getElementById("delete_packages");
        const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
        if (modalInstance) modalInstance.hide();

        fetchRoleData();
        setSelectedRole(null);
      }
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const handleStatusChange = async (role) => {
    try {
      if (!can(permissions, "write", "role")) return;

      const newStatus = role.status === "active" ? "inactive" : "active";

      const res = await RoleApi.updateStatus({
        id: role._id,
        status: newStatus,
      });

      if (res.code === 200) {
        fetchRoleData();
      }
    } catch (err) {
      console.error("Role status update error:", err);
    }
  };

  const filteredRoles = roleData.filter((item) => {
    const search = searchTerm.toLowerCase().trim();

    return item.role?.toLowerCase().includes(search);
  });
  return (
    <div>
      <div className="content pb-0">
        {/* Header */}
        <div className="d-flex align-items-center justify-content-between gap-2 mb-4 flex-wrap">
          <div>
            <h4 className="mb-1">
              Role Management
              <span className="badge badge-soft-primary ms-2">
                {filteredRoles.length}
              </span>
            </h4>
          </div>
        </div>
        <div className="gap-2 d-flex align-items-center mb-3 justify-content-between flex-wrap">
          <div className="group-search-box position-relative">
            <i className="ti ti-search search-icon"></i>

            <input
              type="text"
              className="form-control search-input"
              placeholder="Search by Role..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {/* ✅ Matrix: write permission check for Add button */}
          {can(permissions, "write", "role") && (
            <div className="card-header d-flex align-items-center justify-content-between gap-2 flex-wrap">
              <a
                href="javascript:void(0);"
                className="btn btn-primary"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvas_add"
              >
                <i className="ti ti-square-rounded-plus-filled me-1" />
                Add Role
              </a>
            </div>
          )}
        </div>

        <div className="card border-0 rounded-0 shadow-sm">
          <div className="card-body">
            <div className="table-responsive custom-table">
              <table className="table table-nowrap align-middle">
                <thead className="table-light">
                  <tr>
                    <th>S.no</th>
                    <th>Role Name</th>
                    <th>Created on</th>
                    <th>Status</th>

                    {/* Action column toggle based on permissions */}
                    {(can(permissions, "write", "role") ||
                      can(permissions, "delete", "role")) && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {roleData.length > 0 ? (
                    filteredRoles.map((item, index) => (
                      <tr key={item._id}>
                        <td>{index + 1}</td>
                        <td className="fw-bold">{item.role}</td>
                        <td>{formatDate(item.createdAt, true)}</td>
                        <td>
                          <div className="d-flex gap-2">
                            {/* Edit Button */}
                            {can(permissions, "write", "role") && (
                              <a
                                className="btn btn-soft-success btn-sm"
                                href="#"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvas_edit"
                                onClick={() => setEditData(item)}
                              >
                                <i className="ti ti-edit" />
                              </a>
                            )}

                            {/* Activate / Deactivate Role */}
                            {can(permissions, "write", "role") && (
                              <button
                                type="button"
                                className={`btn btn-sm ${
                                  item.status === "active"
                                    ? "btn-soft-warning"
                                    : "btn-soft-success"
                                }`}
                                onClick={() => handleStatusChange(item)}
                                title={
                                  item.status === "active"
                                    ? "Deactivate Role"
                                    : "Activate Role"
                                }
                              >
                                <i
                                  className={
                                    item.status === "active"
                                      ? "ti ti-user-off"
                                      : "ti ti-user-check"
                                  }
                                />
                              </button>
                            )}

                            {/* Delete Button */}
                            {can(permissions, "delete", "role") && (
                              <a
                                className="btn btn-soft-danger btn-sm"
                                href="#"
                                data-bs-toggle="modal"
                                data-bs-target="#delete_packages"
                                onClick={() => setSelectedRole(item)}
                              >
                                <i className="ti ti-trash"></i>
                              </a>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center py-4 text-muted">
                        No roles found in the system.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div className="modal fade" id="delete_packages">
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body p-4 text-center">
              <div className="mb-3">
                <span className="avatar avatar-xl badge-soft-danger rounded-circle">
                  <i className="ti ti-trash fs-24" />
                </span>
              </div>
              <h5 className="mb-1">Delete Role?</h5>
              <p className="small text-muted mb-3">
                This will affect users assigned to this role.
              </p>
              <div className="d-flex justify-content-center gap-2">
                <button
                  type="button"
                  className="btn btn-light w-100"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  onClick={handleDelete}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* offcanvas */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_add"
      >
        <AddDetails refreshList={fetchRoleData} />
      </div>
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_edit"
      >
        <EditDetails data={editData} refreshList={fetchRoleData} />
      </div>
    </div>
  );
}

export default List;
